import React from "react";
import { Navigate, generatePath, useParams } from "react-router-dom";
import { paths } from "~/router/paths";

/** Old bookmarks → `/store-library/insights/:storeId` */
export const LegacyStoreLibraryInsightsRedirect: React.FC = () => {
  const { storeId } = useParams<{ storeId: string }>();
  if (!storeId) return <Navigate to={paths.app.storeLibrary} replace />;
  return (
    <Navigate to={generatePath(paths.app.storeInsights, { storeId })} replace />
  );
};
